// Wunschtermin: Schnellknöpfe setzen das Datumsfeld, das versteckte Feld bekommt TT.MM.JJJJ für die Bestellung.
// Alles in Ortszeit (toISOString rechnet in UTC und verschiebt je nach Uhrzeit den Tag). Die Prüfung läuft über
// setCustomValidity, das Formular (baukasten.js bzw. theme.js) zeigt die Meldung an.
(() => {
  const zwei = (n) => String(n).padStart(2, '0');
  const iso = (d) => `${d.getFullYear()}-${zwei(d.getMonth() + 1)}-${zwei(d.getDate())}`;
  const deutsch = (wert) => wert.split('-').reverse().join('.');
  const plusTage = (tage) => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + tage);
  };
  // gleicher Tag im nächsten Monat, am Monatsende auf den letzten Tag gekürzt (31.01. wird 28.02.)
  const plusMonate = (monate) => {
    const d = new Date();
    const letzter = new Date(d.getFullYear(), d.getMonth() + monate + 1, 0).getDate();
    return new Date(d.getFullYear(), d.getMonth() + monate, Math.min(d.getDate(), letzter));
  };

  const init = (root) => {
    if (root.__wt) return;
    root.__wt = true;
    const datum = root.querySelector('[data-wt-datum]');
    const wert = root.querySelector('[data-wt-wert]');
    const knoepfe = [...root.querySelectorAll('[data-wt-tage], [data-wt-monate]')];
    const pflicht = datum.getAttribute('aria-required') === 'true';
    const ziel = (k) => iso(k.dataset.wtMonate ? plusMonate(Number(k.dataset.wtMonate)) : plusTage(Number(k.dataset.wtTage)));
    // frühestens übermorgen; im Browser gesetzt, weil Shopify "now" in Liquid zwischenspeichert
    const min = iso(plusTage(2));
    datum.min = min;

    const sync = () => {
      const v = datum.value;
      wert.value = v ? deutsch(v) : '';
      knoepfe.forEach((k) => k.setAttribute('aria-pressed', String(v !== '' && ziel(k) === v)));
      datum.setCustomValidity(
        !v ? (pflicht ? 'Bitte wählen Sie, bis wann Ihre Website fertig sein soll.' : '')
          : v < min ? `Bitte wählen Sie ein Datum ab dem ${deutsch(min)}.`
          : ''
      );
    };
    knoepfe.forEach((k) => k.addEventListener('click', () => {
      // nochmal klicken hebt die Auswahl auf, wie bei den Chips
      datum.value = k.getAttribute('aria-pressed') === 'true' ? '' : ziel(k);
      datum.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    datum.addEventListener('input', sync);
    datum.addEventListener('change', sync);
    sync();
  };

  const start = (scope) => scope.querySelectorAll('[data-wunschtermin]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
})();
